/**
 * API Configuration
 * Easily switch between local development and production environments
 */

const ENV = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production'
};

// Change this to switch environments
const CURRENT_ENV = ENV.PRODUCTION; // Change to ENV.PRODUCTION for production

const API_URLS = {
  [ENV.DEVELOPMENT]: 'http://localhost:5001/api',
  [ENV.PRODUCTION]: 'https://hopbackend.onrender.com/api' // Replace with your actual production URL
};

// API Configuration
const apiConfig = {
  baseURL: API_URLS[CURRENT_ENV],
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json'
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${apiConfig.baseURL}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    ...apiConfig.headers,
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

// Helper function to get auth headers for FormData (file uploads)
// Don't set Content-Type - let browser set it automatically with boundary
export const getAuthHeadersForFormData = () => {
  const token = localStorage.getItem('token');
  return {
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

// Export configuration
export const API_BASE_URL = apiConfig.baseURL;
export const API_TIMEOUT = apiConfig.timeout;
export const CURRENT_ENVIRONMENT = CURRENT_ENV;

export default apiConfig;
